export const steps = [
  'const_proposal_sumary',
  'const_process_analysis',
  'const_scope_registration',
  'const_attachments'
];
